import {Box, Typography} from '@mui/material';
import {ReactNode} from 'react';

interface SectionHeadingProps {
    title: string;
    description: string;
    children: ReactNode;
}

const SectionHeading = ({title, description, children}: SectionHeadingProps) => (
    <Box component='section' sx={{mb: 4}}>
        <Typography variant='h6' component='h2' sx={{fontWeight: 600, lineHeight: 1.3}}>
            {title}
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{mt: 0.5, mb: 2, maxWidth: '75ch'}}>
            {description}
        </Typography>
        {children}
    </Box>
);

export default SectionHeading;
